export default __webpack_public_path__ + "static/media/honeymob4.56f22c1d.webp";